import { Platform } from 'react-native'
import type { TextStyle, ViewStyle } from 'react-native'
import styled, { DefaultTheme } from 'styled-components/native'

import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'

export const getNoticeTitleStyle = (theme: DefaultTheme): TextStyle => ({
  color: theme.colors.text,
  fontWeight: 'normal',
})

export const getPickerContainerStyle = (theme: DefaultTheme): ViewStyle => ({
  paddingTop: 0,
  flex: 1,
  backgroundColor: theme.colors.background,
  justifyContent: 'center',
  alignItems: Platform.select({ default: 'center', web: 'stretch' }),
  display: 'flex',
})

export const getNoticeStyle = (theme: DefaultTheme): ViewStyle => ({
  backgroundColor: theme.colors.bannerBg,
  paddingTop: 4,
  paddingBottom: 4,
})

export const getImagePickerStyle = (theme: DefaultTheme): ViewStyle => ({
  flex: 1,
  backgroundColor: theme.colors.background,
  marginBottom: (theme.insets.bottom || theme.metrics.baseMargin) + theme.metrics.button.height,
})

export const getFooterSpacingStyle = (theme: DefaultTheme): ViewStyle => ({
  paddingBottom:
    (theme.insets.bottom || theme.metrics.baseMargin) + 48 + theme.metrics.baseMargin / 2,
})

export const HintContainer = styled.View`
  position: absolute;
  top: 10px;
  right: ${({ theme }) => theme.metrics.baseMargin}px;
  z-index: 10;
`

export const HintContent = styled.View`
  position: relative;
`

export const HintIconButton = styled(DialogueTouchableOpacity)`
  padding: 11px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const HintIcon = styled.Image`
  height: 20px;
  width: 20px;
  tint-color: ${({ theme }) => theme.colors.text};
`

export const PopoverWindow = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  top: -10px;
  right: 100%;
  transform: translateX(${({ theme }) => -theme.metrics.baseMargin / 2}px)
    translateY(${({ theme }) => theme.metrics.baseMargin / 2}px);
  max-width: ${({ theme }) => theme.metrics.screenWidth - theme.metrics.baseMargin}px;
  min-width: ${({ theme }) => 0.65 * theme.metrics.screenWidth}px;
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  elevation: 2;
  align-content: center;
  display: flex;
  position: absolute;
  ${({ theme }) => theme.shadows.soft};
`

export const PopoverTail = styled.View`
  position: absolute;
  top: ${({ theme }) => theme.metrics.baseMargin / 2 + 2}px;
  right: -25px;
  width: 0;
  height: 0;
  background-color: transparent;
  border-style: solid;
  border-top-width: 14px;
  border-right-width: 14px;
  border-bottom-width: 14px;
  border-left-width: ${({ theme }) => theme.metrics.baseMargin}px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: ${({ theme }) => theme.colors.elementsBg};
`

export const PopoverContent = styled.View`
  margin: ${({ theme }) => theme.metrics.baseMargin}px;
  flex-direction: column;
  display: flex;
`

export const PopoverSubtitle = styled.Text`
  ${({ theme }) => theme.fonts.styles.body};
  font-size: ${({ theme }) => theme.fonts.fontSize.small}px;
  color: ${({ theme }) => theme.colors.text};
  align-items: baseline;
  text-align: center;
`

export const Footer = styled.View`
  position: absolute;
  bottom: ${({ theme }) => theme.insets.bottom || theme.metrics.baseMargin}px;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

export const ActionButtonContainer = styled.View`
  width: 50%;
`
